// Fork JavaMifi: Settings → Organizations (khusus administrator).
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/organizations'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'organizations_list',
          meta: { permissions: ['administrator'] },
          component: Index,
        },
      ],
    },
  ],
};
